// extracted by mini-css-extract-plugin
export default {"wrapper":"PageHeader_wrapper__fAbjU","image":"PageHeader_image__O09qM"};